<head>
	<!-- Google Tag Manager -->
  
	<script>(function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer', 'GTM-KB72W5J');</script>
  
	<!-- End Google Tag Manager -->
  </head>
  <!-- Google Tag Manager (noscript) -->
  
  <noscript>
	<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KB72W5J" height="0" width="0" style="display:none;visibility:hidden"></iframe>
  </noscript>
  
  <!-- End Google Tag Manager (noscript) -->
<div class="template" style="font-size:large" *ngIf="!mobile">

            <ul style="margin-left: 22%; margin-top: 2%; margin-bottom: 2%;">
                <a [routerLink]="['']"><li>Home</li></a>
                <ul style="margin-left: 3%; margin-bottom: 0%">
                    <a [routerLink]="['/information/about-backseat-trader-and-etoro']"><li>About Backseat Trader and Etoro</li></a>
                    <a [routerLink]="['/information/smart-stock-curation']"><li>Smart Stock Curation</li></a>
                    <a [routerLink]="['/information/advanced-analytics-and-intelligence']"><li>Advanced Analytics and Intelligence</li></a>
                    <a [routerLink]="['/information/diversified-approach']"><li>Diversified Approach</li></a>
                    <a [routerLink]="['/information/methodology']"><li>Methodology</li></a>
                    <ul style="margin-left: 3%; margin-bottom: 0%">
                        <a [routerLink]="['/information/methodology/runs-on-four-hour-bars']"><li>Runs on 4 Hour Bars</li></a>
                        <a [routerLink]="['/information/methodology/trades-a-portfolio-of-most-liquid-currencies-indices-and-commodities']"><li>Trades a portfolio of most liquid currencies (6), indices (5), and commodities (2)</li></a>
                        <a [routerLink]="['/information/methodology/trades-10-separate-algorithms-components-in-parallel']"><li>Trades 10 separate algorithms components in parallel (5 trend following and 5 mean reversion)</li></a>
                        <a [routerLink]="['/information/methodology/rolling-window-walk-forward-optimisation-over-7-years-period']"><li>Rolling window walk-forward optimisation over 7 years period</li></a>
                        <a [routerLink]="['/information/methodology/support-for-leveraged-and-unleveraged-accounts']"><li>Volatility-adjusted trade exit logic</li></a>
                        <a [routerLink]="['/information/methodology/capital-allocation-and-position-sizing-based-on-optimalf-factors']"><li>Capital allocation and position sizing based on OptimalF factors</li></a>
                    </ul>

                    <a [routerLink]="['/information/how-it-works']"><li>How It Works</li></a>
                </ul>                    
                <a [routerLink]="['/academy']"><li>Academy</li></a>
                <a [routerLink]="['/etoro']"><li>Live</li></a>
                <a [routerLink]="['/user']"><li>Profile</li></a>
                <a [routerLink]="['/login']"><li>Login</li></a>
                <a [routerLink]="['/register']"><li>Register</li></a>
                <a [routerLink]="['/newsletter']"><li>Newsletter</li></a>
                <a [routerLink]="['/cosmos']"><li>Cosmos</li></a>
                <!-- <a [routerLink]="['/join-us']"><li>Join Us</li></a> -->
            </ul>

</div>

<div class="template" style="font-size:large" *ngIf="mobile">

    <ul style="margin-left: 32%; margin-top: 2%; margin-bottom: 2%;">
        <a [routerLink]="['']"><li>Home</li></a>
        <ul style="margin-left: 10%; margin-bottom: 0%">
            <a [routerLink]="['/information/about-backseat-trader-and-etoro']"><li>About Backseat Trader and Etoro</li></a>
            <a [routerLink]="['/information/smart-stock-curation']"><li>Smart Stock Curation</li></a>
            <a [routerLink]="['/information/advanced-analytics-and-intelligence']"><li>Advanced Analytics and Intelligence</li></a>
            <a [routerLink]="['/information/diversified-approach']"><li>Diversified Approach</li></a>
            <a [routerLink]="['/information/methodology']"><li>Methodology</li></a>
            <ul style="margin-left: 3%; margin-bottom: 0%">
                <a [routerLink]="['/information/methodology/runs-on-four-hour-bars']"><li>Runs on 4 Hour Bars</li></a>
                <a [routerLink]="['/information/methodology/trades-a-portfolio-of-most-liquid-currencies-indices-and-commodities']"><li>Trades a portfolio of most liquid currencies (6), indices (5), and commodities (2)</li></a>
                <a [routerLink]="['/information/methodology/trades-10-separate-algorithms-components-in-parallel']"><li>Trades 10 separate algorithms components in parallel (5 trend following and 5 mean reversion)</li></a>
                <a [routerLink]="['/information/methodology/rolling-window-walk-forward-optimisation-over-7-years-period']"><li>Rolling window walk-forward optimisation over 7 years period</li></a>
                <a [routerLink]="['/information/methodology/support-for-leveraged-and-unleveraged-accounts']"><li>Volatility-adjusted trade exit logic</li></a>
                <a [routerLink]="['/information/methodology/capital-allocation-and-position-sizing-based-on-optimalf-factors']"><li>Capital allocation and position sizing based on OptimalF factors</li></a>
            </ul>

            <a [routerLink]="['/information/how-it-works']"><li>How It Works</li></a>
        </ul>             
        <a [routerLink]="['/academy']"><li>Academy</li></a>
        <a [routerLink]="['/etoro']"><li>Live</li></a>
        <a [routerLink]="['/user']"><li>Profile</li></a>
        <a [routerLink]="['/login']"><li>Login</li></a>
        <a [routerLink]="['/register']"><li>Register</li></a>
        <a [routerLink]="['/newsletter']"><li>Newsletter</li></a>
        <a [routerLink]="['/cosmos']"><li>Cosmos</li></a>
        <!-- <a [routerLink]="['/join-us']"><li>Join Us</li></a> -->
    </ul>

</div>
